import ReactDOM from 'react-dom'
import Modal from './Modal'
console.log(window.variables)
ReactDOM.render(
  <Modal/>,
  document.getElementById('rootIMC')
)
